import { Category } from '@modules/common/types';
import { mapCategoryToEdgeCategory } from '@modules/common/utils';
import { TrackedKeywordPrediction } from '@modules/feedback/store/types';
import { EntityManipulationType } from 'generated/graphql';

export const toTrackedKeywordManipulations = (
  trackedKeywordPredictions?: TrackedKeywordPrediction[],
) => {
  if (!trackedKeywordPredictions?.length) {
    return [];
  }

  return trackedKeywordPredictions.map((trackedKeywordPrediction) => ({
    manipulationType: trackedKeywordPrediction.manipulationType,
    entity: {
      labelID: trackedKeywordPrediction.prediction.id,
      oldCategory: mapCategoryToEdgeCategory(
        trackedKeywordPrediction.oldCategory,
      ),
      newCategory: mapCategoryToEdgeCategory(trackedKeywordPrediction.category),
      type:
        !trackedKeywordPrediction.category ||
        trackedKeywordPrediction.category === Category.Uncategorized
          ? EntityManipulationType.Add
          : EntityManipulationType.Modify,
    },
  }));
};
